import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';

const CardStyled = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	flex: 1;
	background: #4e4e4e;
	color: white;
`

const CountContainer = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-weight: 700;
	font-size: 25px;

	margin: 20px;
`
const Label = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 18px;
	font-weight: 700;
`
const MainIcon = styled(Icon)`
	position: absolute;
	left: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 35px;
	margin-left: 20px;
`
//TODO: create info card models
const MainCard = ({
  label,
	count,
	icon,
  ...other
}) => {

  return (
		<CardStyled {...other}>
			<CountContainer>{count}</CountContainer>
			{
				icon ? (
					<MainIcon>{icon}</MainIcon>
				) : (
					<CountContainer>{count}</CountContainer>
				)
			}
			<Label>{label}</Label>
    </CardStyled>
  )
}

MainCard.propTypes = {
  label: PropTypes.string,
  count: PropTypes.number,
  AlertText: PropTypes.string,
};

MainCard.defaultProps = {
    
};

export default MainCard;
